<template>
  <div id="app">
    <Mygraph />

    <!-- <custom-dialog v-if="!is_session_expired" @close="is_session_expired=false"></custom-dialog> -->
    <router-view />
    <b-loading :is-full-page="true" :active.sync="is_loading" :can-cancel="true"></b-loading>
  </div>
</template>
<script>
import CustomDialog from "./components/dialog/dialog.component";
import { mapState, mapMutations } from "vuex";
import api from "./api.service";
import Mygraph from "./plotly-graph";
const apiService = new api();
import jwt_decode from "jwt-decode";

export default {
  components: {
    CustomDialog,
    Mygraph,
  },
  data() {
    return {
      is_session_expired: true
    };
  },
  async created() {
    let details = await apiService.get_view_details({
      id: this.$route.params.uid,
      query: "metrics=true"
    });
    this.$store.commit("SET_VIEW_DETAILS", details.data);

    this.update_feature_props_from_parent();
    // this.$root.$on("token_expired", () => {
    //   parent.postMessage("token_expired", "*");
    //   this.is_session_expired = false;
    // });

    await this.initialize();
    if (window.$cookies.get("access_token"))
      this.$store
        .dispatch("get_orthos", this.$route.params.uid)
        .then(res => {
          if (res && res.data) {
            res.data = res.data.filter(
              p => !p.properties || !p.properties.is_disabled
            );
          }
          this.SET_ORTHOS(res.data);
        })
        .catch(err => {
          console.log(err);
          this.handleErrors(err);
          console.log("Error :: while loading view");
        });
  },
  computed: {
    ...mapState(["token", "claims", "api_host", "orthos", "is_loading", "draw","lang_data"])
  },
  watch: {
    draw(val) {
      if (val) this.LOAD_SOURCES();
    },
    // Everytime the route changes, check for auth status
    $route: "isAuthenticated"
  },
  methods: {
    ...mapMutations([
      "SET_TOKEN",
      "SET_CLAIMS",
      "SET_ORTHOS",
      "LOAD_SOURCES",
      "SET_SPLIT_CLIENT",
      "SET_LANG_DATA"
    ]),
    isAuthenticated() {
      if (!window.$cookies.get("access_token")) {
        this.is_session_expired = false;
      }
    },
    initialize_split() {
      // Instantiate the SDK. CDN will expose splitio globally
      let decodedJwt = jwt_decode(window.$cookies.get("access_token"));

      var factory = splitio({
        core: {
          authorizationKey: process.env.VUE_APP_SPLIT_KEY,
          // your internal user id, or the account id that
          // the user belongs to.
          // This coudld also be a cookie you generate
          // for anonymous users
          key: decodedJwt.sub || decodedJwt.email || this.claims.email,
          // an OPTIONAL traffic type, if provided will be
          // used for event tracking with the SDK client.
          trafficType: "A_TRAFFIC_TYPE"
        }
      });
      // And get the client instance you'll use
      var client = factory.client();
      client.on(client.Event.SDK_READY, () => {
        this.SET_SPLIT_CLIENT(client);
      });
    },
    async initialize() {
      if (!window.$cookies.get("access_token")) {
        this.is_session_expired = false;
      } else {
        this.SET_TOKEN(window.$cookies.get("access_token"));

        try {
          let res = await apiService.get_claims();
          if (res && res.data) {
            this.SET_CLAIMS(res.data);
            this.initialize_split();
          } else this.is_session_expired = false;
        } catch (err) {
          this.is_session_expired = false;
        }
      }
    },
    update_feature_props_from_parent() {
      if (window.addEventListener) {
        window.addEventListener(
          "message",
          e => {
            console.log(e);
            if (e.data.name === "update_feature_props") {
              this.draw.setFeatureProperty(
                e.data.feature.id,
                "element",
                e.data.element
              );
            }else if(e.data && e.data.name === "lang_data"){
              console.log("lang",e.data)
              this.SET_LANG_DATA(e.data.data ||{})
            }
          },
          false
        );
      } else if (window.attachEvent) {
        window.attachEvent("onmessage", e => {
          if (e.data.name === "update_feature_props") {
            this.draw.setFeatureProperty(
              e.data.feature.id,
              "element",
              e.data.element
            );
          }else if(e.data && e.data.name === "lang_data"){
            console.log("lang",e.data)
              this.SET_LANG_DATA(e.data.data)
            }
        });
      }
    }
  }
};
</script>
<style lang="scss">
@import "~bulma-slider/dist/css/bulma-slider.min.css";
@import "~bulma-checkradio/dist/css/bulma-checkradio.min.css";

@font-face {
  font-family: "Barlow-Black";
  src: url(./assets/fonts/Barlow-Black.ttf);
}
@font-face {
  font-family: "Barlow-BlackItalic";
  src: url(./assets/fonts/Barlow-BlackItalic.ttf);
}
@font-face {
  font-family: "Barlow-Bold";
  src: url(./assets/fonts/Barlow-Bold.ttf);
}
@font-face {
  font-family: "Barlow-BoldItalic";
  src: url(./assets/fonts/Barlow-BoldItalic.ttf);
}
@font-face {
  font-family: "Barlow-ExtraBold";
  src: url(./assets/fonts/Barlow-ExtraBold.ttf);
}
@font-face {
  font-family: "Barlow-ExtraBoldItalic";
  src: url(./assets/fonts/Barlow-ExtraBoldItalic.ttf);
}
@font-face {
  font-family: "Barlow-ExtraLight";
  src: url(./assets/fonts/Barlow-ExtraLight.ttf);
}
@font-face {
  font-family: "Barlow-ExtraLightItalic";
  src: url(./assets/fonts/Barlow-ExtraLightItalic.ttf);
}
@font-face {
  font-family: "Barlow-Italic";
  src: url(./assets/fonts/Barlow-Italic.ttf);
}
@font-face {
  font-family: "Barlow-Light";
  src: url(./assets/fonts/Barlow-Light.ttf);
}
@font-face {
  font-family: "Barlow-LightItalic";
  src: url(./assets/fonts/Barlow-LightItalic.ttf);
}
@font-face {
  font-family: "Barlow-Medium";
  src: url(./assets/fonts/Barlow-Medium.ttf);
}
@font-face {
  font-family: "Barlow-MediumItalic";
  src: url(./assets/fonts/Barlow-MediumItalic.ttf);
}
@font-face {
  font-family: "Barlow";
  src: url(./assets/fonts/Barlow-Regular.ttf);
}
@font-face {
  font-family: "Barlow-Regular";
  src: url(./assets/fonts/Barlow-Regular.ttf);
}
@font-face {
  font-family: "Barlow-SemiBold";
  src: url(./assets/fonts/Barlow-SemiBold.ttf);
}
@font-face {
  font-family: "Barlow-SemiBoldItalic";
  src: url(./assets/fonts/Barlow-SemiBoldItalic.ttf);
}
@font-face {
  font-family: "Barlow-Thin";
  src: url(./assets/fonts/Barlow-Thin.ttf);
}
@font-face {
  font-family: "Barlow-ThinItalic";
  src: url(./assets/fonts/Barlow-ThinItalic.ttf);
}
.is-semiBold-16-600-19 {
  font-family: Barlow-SemiBold !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 19px !important;
}
.is-medium-16-500-19 {
  font-family: Barlow-Medium;
  font-size: 16px;
  font-weight: 500;
  line-height: 19px;
  color: #171e48;
}
.is-semibold-12-500-14 {
  font-family: Barlow-Medium;
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
}
.is-semibold-16-600-19 {
  font-family: Barlow-SemiBold;
  font-size: 16px;
  font-weight: 600;
  line-height: 19px;
  color: #171e48;
}
.is-regular-16-000-42 {
  font-family: Barlow-Regular !important;
  font-size: 16px;
  font-weight: normal;
  line-height: 42px !important;
}
.is-medium-14-500-42 {
  font-family: Barlow-Medium;
  font-size: 14px;
  font-weight: 500;
  line-height: 42px !important;
}
.is-semiBold-14-600-42 {
  font-family: Barlow-SemiBold !important;
  font-size: 14px;
  font-weight: 600;
  line-height: 42px !important;
}
.is-semiBold-15-500-42 {
  font-family: Barlow-SemiBold !important;
  font-size: 14.5px;
  font-weight: 500;
  line-height: 42px !important;
}
.is-bold-16-000-106 {
  font-family: Barlow-Bold !important;
  font-size: 16px;
  font-weight: normal;
  line-height: 80px;
}
.is-semibold-16-000-106 {
  font-family: Barlow-SemiBold !important;
  font-size: 16px;
  font-weight: normal;
}

html,
body {
  overflow: hidden;
  font-family: "Barlow";
}

#app {
  font-family: Barlow-Regular;
}

.heading-secondary {
  font-weight: 500;
  font-size: 13px;
  text-transform: uppercase;
}
.is-pointer {
  cursor: pointer;
}

.tooltip {
  font-family: Barlow-Medium;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: 0.06px;
  font-size: 13px;
  display: block !important;
  z-index: 10000;

  .tooltip-inner {
    background: #171e48;
    color: white;
    border-radius: 4px;
    padding: 4px 7px 8px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[aria-hidden="true"] {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.15s, visibility 0.15s;
  }

  &[aria-hidden="false"] {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.15s;
  }
}
</style>



